import intl from 'react-intl-universal';
import React from 'react';
import { default as Button } from '@/components/CssBtn';
import { ModalForm } from '@ant-design/pro-components';

const CssModalForm: React.FC<any> = (props) => {
    const { children, onFinish, ...restProps } = props;
    return (
        <ModalForm
            {...restProps}
            onFinish={onFinish}
            submitter={{
                submitButtonProps: {
                    style: {
                        display: 'none',
                    },
                },
                render: (props, defaultDoms) => {
                    return [
                        ...defaultDoms,
                        <Button
                            {...props}
                            key="submit"
                            type="primary"
                            onClick={() => props.form?.submit?.()}
                        >
                            {intl.get('确定')}
                        </Button>,
                    ];
                },
            }}
        >
            {children}
        </ModalForm>
    );
};

export default CssModalForm;
